import { Component, OnInit } from '@angular/core';
import { AppSettings, HelperService, AuthenticationService } from '../../services/_services';
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import Swal from 'sweetalert2';

@Component({
  selector: 'app-leads-alerts',
  templateUrl: './leads-alerts.component.html',
  styleUrls: ['./leads-alerts.component.css']
})
export class LeadsAlertsComponent implements OnInit {

  public leads                                    : any = [];
  public lead_Index                               : any;
  public siteAbbr                                 : any = AppSettings.siteAbbr;
  public alertType                                : any = 'lead';
  public allLeadAlertsBuffer                      : any = [];
  public hideEmailBucket                          : any = false;
  public loggedAgent                              : any = [];
  public bufferSize                               : any = 50;
  public loadingAlerts                            : any = false;
  public loading                                  : any = false;
  public numberOfItemsFromEndBeforeFetchingMore   : any = 10;
  public showalertNoti                            : any = false;

  constructor(
    private helperService         : HelperService,
    private authenticationService : AuthenticationService,
    // private alertIdService        : AlertIdService,
    private router                : Router,
  ) { }

  ngOnInit() {
    this.loggedAgent = this.authenticationService.get_currentUserValue();
    let self = this;

    // Initial Call
    self.getLeads();

    // Call after every 15 mins
    setInterval(function(){
      self.getLeads();
    }, 900000);
  }

  toggleEmailBucket() {
    this.hideEmailBucket = !this.hideEmailBucket;
  }

  selectAlertType(type) {
    if(this.alertType != type) {
      this.alertType = type;
      this.getLeads();
    }
  }

  getLeads() {
    let url  = '';

    if(this.alertType == 'lead')
      url  = AppSettings.API_ENDPOINT + 'admin/missed-leads-alerts';
    else
      url  = AppSettings.API_ENDPOINT + 'admin/missed-unpaid-alerts';

    // https://backend.skyscrapersnow.com/api/admin/missed-alerts
    // type (lead, unpaid)
    // shift (morning, evening, night)

    // if(this.loggedAgent.is_admin != '1')
    //   url += '&agent_id=' + this.loggedAgent.id;

    // Show loader
    this.loadingAlerts = true;
    this.leads         = [];

    // this.helperService.httpPostRequests(url, { type: 'lead', shift: 'morning' })
    this.helperService.httpPostRequests(url, { type: this.alertType })
      .then(resp => {
        if (typeof resp != "undefined" && resp != null && typeof resp.error === "undefined" ) {
          this.leads = resp.response;
          this.allLeadAlertsBuffer = this.leads.slice(0, this.bufferSize);

          if(this.leads.length > 0)
            this.hideEmailBucket = true;
        }

        // Hide loader
        this.loadingAlerts = false;
      })
      .catch(error => {
        console.log("error: ",error);

        // Hide loader
        this.loadingAlerts = false;
      });
  }

  // searchLeads(event: any) {
  //   this.allLeadAlertsBuffer = this.allLeadIds.filter((x: { lead_id: string }) => x.lead_id.includes(event.term));
  // }

  onScrollToEnd() {
      this.fetchMore();
  }

  onScroll({ end }) {
      if (this.loading || this.leads.length <= this.allLeadAlertsBuffer.length) {
          return;
      }

      if (end + this.numberOfItemsFromEndBeforeFetchingMore >= this.allLeadAlertsBuffer.length) {
          this.fetchMore();
      }
  }

  private fetchMore() {
      const len = this.allLeadAlertsBuffer.length;
      const more = this.leads.slice(len, this.bufferSize + len);
      this.loading = true;
      // using timeout here to simulate backend API delay
      setTimeout(() => {
          this.loading = false;
          this.allLeadAlertsBuffer = this.allLeadAlertsBuffer.concat(more);
      }, 200)
  }

  openAssignToMe_Sales_Modal(index) {
    //Set lead index
    this.lead_Index = index;
    console.log("--- index: ", index);


    // Open Modal
    ($('#assignLeadModal') as any).modal('show');
    $(".modal-backdrop").click(function() {
      ($("#assignLeadModal") as any).modal("hide");
    });
  }

  assignToMe_Sales_Lead() {
    // Hide Modal
    ($('#assignLeadModal') as any).modal('hide');
    $('.modal-backdrop').remove();

    // Show Status Loader
    this.leads[this.lead_Index].loading = true;

    let url = AppSettings.API_ENDPOINT + "sales/assign-lead-to-me";
    let data = { id: this.leads[this.lead_Index].id, status: 1 };

    this.helperService.httpPostRequests(url, data).then(resp => {
      // Hide Status Loader
      this.leads[this.lead_Index].loading = false;

      if (typeof resp != "undefined" && resp.status == "OK") {
        Swal.fire('', resp.message, 'success');

        // Update Alerts
        this.getLeads();
      }

      if (typeof resp != "undefined" && resp.status == "ERROR") {
        Swal.fire('', resp.message, 'error');
      }
    }).catch(err => {
      // Hide Status Loader
      this.leads[this.lead_Index].loading = false;

      Swal.fire('', err.error.message, 'error');
    });
  }

  assignToMe_Sales_Unpaid() {
    // Hide Modal
    ($('#assignLeadModal') as any).modal('hide');
    $('.modal-backdrop').remove();

    // Show Status Loader
    this.leads[this.lead_Index].loading = true;

    let url = AppSettings.API_ENDPOINT + "sales/assign-unpaid-order-to-me";
    let data = { id: this.leads[this.lead_Index].id, status: 1 };

    this.helperService.httpPostRequests(url, data).then(resp => {
      // Hide Status Loader
      this.leads[this.lead_Index].loading = false;

      if (typeof resp != "undefined" && resp.status == "OK") {
        Swal.fire('', resp.message, 'success');

        // Update Alerts
        this.getLeads();
      }

      if (typeof resp != "undefined" && resp.status == "ERROR") {
        Swal.fire('', resp.message, 'error');
      }
    }).catch(err => {
      // Hide Status Loader
      this.leads[this.lead_Index].loading = false;
      Swal.fire('', 'Something went wrong. Please try again.', 'error');
    });
  }

  removeLead(index) {
    this.leads.splice(index, 1);
  }

  copytext(text){
    let selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = text;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);

      this.showalertNoti= true;
      setTimeout(() => {
        this.showalertNoti= false;
      }, 2000);
  }

  checkAlertTime(alertTime) {
    let alertTimestamp = new Date(alertTime.replace(/\s/g, "T"));
    alertTimestamp     = new Date(alertTimestamp.getTime() + (30 * 60000))
    // let minsToAdd   = 30;
    // let currentTime = new Date(new Date().getTime() + (minsToAdd * 60000))
    let currentTime = new Date();

    if(currentTime < alertTimestamp)
      return true;
    else
      return false;
  }

  getAssignDeadlineTime(leadTime, limit, assignedTime = null ) {
    leadTime   = new Date(leadTime.replace(/\s/g, "T"));
    leadTime   = new Date(leadTime.getTime() + (limit * 60000));
    let delta = 0;
    if(assignedTime)
    {
      assignedTime   = new Date(assignedTime.replace(/\s/g, "T"));
      assignedTime   = new Date(assignedTime.getTime());
      delta  = Math.round((leadTime.getTime() - assignedTime.getTime()) / (1000));
    }
    else
       delta  = Math.round((leadTime.getTime() - this.convertTZ(new Date(), 'America/Los_Angeles').getTime()) / (1000));
    // console.log("delta ", delta);
    // this.cdr.detectChanges();
    // jugaar for exact seconds
    if(delta == 0)
      delta++;
    // jugaar end
    if(delta > 0)
      return delta;
    else
      return 0;
  }

  getAssignLateTime(leadTime, limit, assignedTime = null) {
    // this.navDateTime = this.convertTZ(new Date(), 'America/Los_Angeles');
    // this.myInterval = setInterval(() => {
    //   this.navDateTime = this.convertTZ(new Date(), 'America/Los_Angeles');
    // }, 20000);

    leadTime   = new Date(leadTime.replace(/\s/g, "T"));
    leadTime   = new Date(leadTime.getTime() + (limit * 60000));


    let delta = 0;
    if(assignedTime)
    {
      assignedTime   = new Date(assignedTime.replace(/\s/g, "T"));
      assignedTime   = new Date(assignedTime.getTime());
      delta  = Math.round(( assignedTime.getTime() - leadTime.getTime()) / (1000));
    }
    else {
      delta = Math.round(( this.convertTZ(new Date(), 'America/Los_Angeles').getTime() - leadTime.getTime() ) / (1000));
    }
    // console.log("delta ", delta);
    // this.cdr.detectChanges();
    if(delta > 0)
      return delta;
    else
      return 0;
  }

  convertTZ(date, tzString) {
    return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzString}));
  }

  // goToMissedAlert(alertID) {
  //   // this.alertIdService.setAlertId(alertID);
  //
  //   if(this.loggedAgent.is_admin == '1' || this.loggedAgent.is_QA == '1'){
  //     this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
  //       this.router.navigate(["/leads"])
  //     );
  //   }
  //   else{
  //     this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
  //       this.router.navigate(["/my-leads"])
  //     );
  //   }
  // }

}
